import {
  canCreateMediaPost,
  getIsStorylineMultiTenantOrganizationEnabled,
  getStorylineSettings,
  getStorylineSettingsStatus,
} from '@ms/yammer-data/dist/domains/storylineSettings/selectors';

import { useSelector } from '../useSelector';

type UseStorylineSettings = () => ReturnType<typeof getStorylineSettings>;
/**
 * @deprecated PERFORMANCE This returns an entire fulfilled settings object and will force re-renders if the settings
 * get updated. This should be replaced by primitive value selectors for individual settings.
 */
export const useStorylineSettings: UseStorylineSettings = () => useSelector(getStorylineSettings);

type UseStorylineSettingsStatus = () => ReturnType<typeof getStorylineSettingsStatus>;
export const useStorylineSettingsStatus: UseStorylineSettingsStatus = () => useSelector(getStorylineSettingsStatus);

type UseIsStorylineMultiTenantOrganizationEnabled = () => ReturnType<
  typeof getIsStorylineMultiTenantOrganizationEnabled
>;
export const useIsStorylineMultiTenantOrganizationEnabled: UseIsStorylineMultiTenantOrganizationEnabled = () =>
  useSelector(getIsStorylineMultiTenantOrganizationEnabled);

type UseCanCreateMediaPost = () => ReturnType<typeof canCreateMediaPost>;
export const useCanCreateMediaPost: UseCanCreateMediaPost = () => useSelector(canCreateMediaPost);
